import { GET_INTERDOC_USERS } from "constants/notebooks";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_INTERDOC_USERS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
